/**
 * 부냥 문의 전화번호 — 대표번호 상수.
 *
 * 정책 (v2 개정, 2026-09-21 대표 결정 5):
 *   - 담당자 현장(is_side_inquiry=false)은 현장번호 노출 허용 (contact_number → model_house_phone),
 *     유효한 번호가 없으면 대표번호 1533-8124 로 폴백.
 *   - 사이드문의 현장(is_side_inquiry=true)은 대표번호 1533-8124 고정.
 *   - 번호 결정은 반드시 domain/inquiry/resolveContactPhone.ts 단일 헬퍼로 한다.
 *   - CTA 컴포넌트의 phone prop 기본값은 이 대표번호(prop 미지정 시 다른 번호 금지).
 *   - 담당자 이름 노출 금지.
 */

import type React from 'react';

export const INQUIRY_PHONE = '1533-8124' as const;

/** `tel:` 스킴용 (하이픈 제거된 raw 숫자) */
export const INQUIRY_PHONE_RAW = '15338124' as const;

/** `<a href={INQUIRY_PHONE_TEL_LINK}>` 형태로 그대로 사용 */
export const INQUIRY_PHONE_TEL_LINK = `tel:${INQUIRY_PHONE_RAW}` as const;

/** 카카오톡 채널 채팅 (옵션 — 별도 채널 운영 시 사용) */
export const INQUIRY_KAKAO_CHANNEL_URL = 'https://pf.kakao.com/_dvpGxd/chat' as const;

/**
 * 카톡 상담 링크 클릭 핸들러.
 *
 * 카카오 채널 채팅의 "이전 페이지"(유입경로)는 pf.kakao.com 요청의 HTTP Referer 로 결정된다.
 * 링크는 이미 `referrerPolicy="unsafe-url"` + `rel="noopener"` + https 로 현재 문서 URL 을 Referer 로 전달한다.
 *
 * 그러나 iOS WebKit(사파리/인앱 브라우저)은 `target="_blank"` 새 창(browsing context)의 Referer 를
 * SPA(history.pushState) 이동 *이전* 최초 로드 URL 로 보내는 한계가 있다.
 * 홈(/)에서 상세로 SPA 이동 후 카톡을 누르면 "이전 페이지"가 상세가 아닌 홈(/)으로 표시되는 원인이다.
 * (직접 접속/새로고침으로 상세에 진입한 경우엔 정상적으로 상세 URL 이 전달된다.)
 *
 * 모바일에서는 동일 탭 이동으로 현재 상세 문서 URL 을 Referer 로 안정적으로 전달한다.
 * 모바일은 탭 이동 후 카카오톡 앱이 위로 열리므로 페이지 이탈 UX 영향이 사실상 없다.
 * 데스크톱은 기존 새 탭 동작을 유지해 현재 페이지를 보존한다.
 */
export function handleKakaoChatClick(e: React.MouseEvent<HTMLAnchorElement>): void {
  if (typeof navigator === 'undefined') return;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    e.preventDefault();
    window.location.href = e.currentTarget.href;
  }
}
